import React from 'react';
import { CTAButton } from './CTAButton';
export function PurchaseSection() {
  return <section id="compra" className="py-5 px-4 bg-black text-white text-center" data-id="element-200">
      <div className="max-w-4xl mx-auto" data-id="element-201">
        <h2 className="text-[20px] font-black mb-2 text-[#F9327E]" data-id="element-202">
          Accedé ahora al Pack Efemérides Listas
        </h2>

        <p className="text-xl md:text-2xl font-medium mb-3 max-w-2xl mx-auto" data-id="element-203">
          Tener todo el material organizado durante el año escolar puede
          ahorrarte muchísimo tiempo y trabajo.
        </p>

        <div className="flex justify-center mb-3" data-id="element-204">
          <img src="https://cdn.magicpatterns.com/uploads/7UwAR2TLhpsyk1xP25L34k/1587ce00-8460-4766-9e3b-a17f83d1fddd.png" alt="Pack Efemérides Listas completo con todos los bonus" className="w-full max-w-[220px] h-auto object-contain drop-shadow-2xl" data-id="element-205" />
        </div>

        <div className="bg-gray-900 p-5 md:p-8 rounded-3xl border-2 border-gray-800 shadow-2xl max-w-2xl mx-auto" data-id="element-206">
          <div className="mb-4" data-id="element-207">
            <p className="text-gray-400 text-lg uppercase tracking-widest font-bold mb-1" data-id="element-208">
              PRECIO ÚNICO
            </p>
            <p className="text-6xl md:text-7xl font-black text-white" data-id="element-209">
              ARS $19.990
            </p>
          </div>

          <CTAButton href="https://checkout.aulamater.online/cart/44066017902691:1" className="w-full text-2xl py-6 mb-4" data-id="element-210">
            👉 QUIERO MI PACK EFEMÉRIDES LISTAS
          </CTAButton>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm md:text-base font-bold text-gray-300" data-id="element-211">
            <span className="flex items-center" data-id="element-212">
              <span className="text-green-500 mr-2" data-id="element-213">✔</span> acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-214">
              <span className="text-green-500 mr-2" data-id="element-215">✔</span> descarga digital
            </span>
            <span className="flex items-center" data-id="element-216">
              <span className="text-green-500 mr-2" data-id="element-217">✔</span> material para todo
              el ciclo lectivo
            </span>
          </div>
        </div>
      </div>
    </section>;
}